import type { AxiosError } from '@ori/axios';
import { observable, action, runInAction } from 'mobx';

import { BaseStore } from './BaseStore';
import type { Categories, Category, Subcategories, Subcategory } from '~/models/supportCenter';

export class CategoryStore extends BaseStore {
  @observable
  categoryCollection: Category[] = [];

  @observable
  subcategoryCollection: Subcategory[] = [];

  baseUrl = '/applications/supportCenter/categories';
  categoryName = '';

  get getCurrentCategoryInstance() {
    const currentCategory = this.categoryCollection.filter(
      (category: Category) => category.CategoryId === this.categoryName,
    );

    return currentCategory[0];
  }

  @action
  loadCategoryCollection = async () => {
    const response = await this.getUrl<Categories>(this.baseUrl);

    if (response.data) {
      const { Collection } = response.data;
      runInAction(() => {
        this.categoryCollection = Collection;
      });
    }

    if (response.error !== undefined) {
      runInAction(() => {
        this.networkError = response.error as AxiosError;
      });
    }

    return response;
  };

  @action
  loadSubcategoryCollection = async (categoryName: string | undefined) => {
    this.categoryName = categoryName ?? '';
    const url = `${this.baseUrl}/${this.categoryName}`;
    const response = await this.getUrl<Subcategories>(url);

    if (response.data) {
      const subcategories = response.data.Subcategories;
      runInAction(() => {
        this.subcategoryCollection = subcategories;
      });
    }

    if (response.error !== undefined) {
      runInAction(() => {
        this.networkError = response.error as AxiosError;
      });
    }

    return response;
  };
}
